export default __webpack_public_path__ + "static/media/left_sura.ddc04029.svg";